export const hourNumbers = [...Array(24).keys()].map((x) => ++x)

export const weekdays = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday'
]

export const days = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
]

export const months = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december'
]

export const taskFrequencies = [
  'daily',
  'weekly',
  'monthly',
  'quarterly',
  'bi-annually',
  'annually'
]

export const shifts = ['opening', 'lunch', 'dinner', 'closing']
export const hours = ['preOpen', 'open', 'shiftChange', 'close', 'afterClose']
export const inventoryDay = 1 // monday

export const positions = [
  'none',
  'manager',
  'cashier',
  'sous chef',
  'team',
  'boh team',
  'prep',
  'expo'
]

export const productLocations = [
  'none',
  'beverage station',
  'cashier',
  'delivery rack',
  'bulkhead',
  'sriracha shelf',
  'first base station',
  'kitchen wire shelving',
  'veggie station',
  'rice station',
  'protein station',
  'office',
  'ware washing sink',
  'chemical shelf',
  'walk-in',
  'bathroom cabinet'
]

export const productCategories = [
  //'paper',
  //'desserts',
  //'beverage',
  //'alcohol',
  //'catering',
  //'dry goods',
  //'chemical',
  //'produce',
  //'frozen',
  //'dairy',

  //Food Cost
  // 'protein',
  // 'produce',
  // 'pantry',
  // 'desert',
  // 'beverage',

  //Other
  // 'disposables',
  // 'cleaning',
  // 'office',
  // 'catering',
  '5210 Baked Goods',
  '5220 Beverages',
  '5232 Pantry',
  '5233 Fruits and Vegetables',
  '5241 Beef',
  '5242 Chicken',
  '5243 Eggs',
  '5244 Pork',
  '5245 Tofu',
  '5410 Cleaning',
  '5420 Disposables',
  '5430 Kitchen',
  '5440 Office'
]

export const invoiceActions = [
  'Received', // qtyReceived input (pre-filled)
  //'Discrepancy: Vendor Out-of-Stock', // qtyReceived input
  'Discrepancy: Wrong Number Received', // qtyReceived input
  'Returned: Poor Quality', // qtyReturned, qtyReceived
  'Returned: Damaged', // qtyReturned, qtyReceived
  'Returned: Incorrect Product', // qtyReturned, qtyReceived
  'Returned: Counting Mistake', // qtyReturned, qtyReceived,
  'Not Received',
  'Canceled'
]

export const inputTypes = Object.freeze({
  number: 'Number',
  boolean: 'Yes/No (If No: Order Par)',
  booleanTrue: 'Yes/No (If Yes: Order Par)'
})

export const storeIds = Object.freeze({
  QMA3fmuFDhmoYhO3iTE0: {
    name: 'Tenleytown'
  },
  iXQnQK0AwBcNfE3AitHo: { name: 'College Park' },
  t18jILFOYT9rfeOKlow3: { name: 'NoMa' },
  testing2: { name: 'Testing2' },
  gi62NOpQwIWNQsLncnDt: { name: 'Westfield' },
  iZUDoKgodfHnOV64TftP: { name: 'Penn Quarter' },
  '1Vb0vpfSufp6vAYdtWG1': { name: 'Rosslyn' },
  Vv8Z2epk1pTXXVMJ3Tcc: { name: 'Navy Yard' },
  IL01: { name: 'North Michigan Ave' },
  IL02: { name: 'River North' },
  IL03: { name: 'Wicker Park' },
  VA02: { name: 'West Falls Church' }
})

export default {
  hourNumbers,
  weekdays,
  days,
  months,
  taskFrequencies,
  inventoryDay,
  positions,
  shifts,
  hours,
  productLocations,
  productCategories,
  invoiceActions,
  inputTypes,
  storeIds
}
